"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
//
const CustomIcons_1 = require("./CustomIcons");
// ----------------------------------------------------------------------
function TreeView(theme) {
    return {
        MuiTreeView: {
            defaultProps: {
                defaultCollapseIcon: (0, jsx_runtime_1.jsx)(CustomIcons_1.TreeViewCollapseIcon, { sx: { width: 20, height: 20 } }),
                defaultExpandIcon: (0, jsx_runtime_1.jsx)(CustomIcons_1.TreeViewExpandIcon, { sx: { width: 20, height: 20 } }),
                defaultEndIcon: (0, jsx_runtime_1.jsx)(CustomIcons_1.TreeViewEndIcon, { sx: { color: 'text.secondary', width: 20, height: 20 } }),
            },
        },
        MuiTreeItem: {
            styleOverrides: {
                label: {
                    ...theme.typography.body2,
                },
                iconContainer: {
                    width: 'auto',
                },
            },
        },
    };
}
exports.default = TreeView;
